import { ROOM_SEARCH } from "constants/event_names";
import ReactGA from "react-ga4";
export default function useHandleFirebaseEvents() {
  const registerSearchEvent = (params) => {
    ReactGA.event(ROOM_SEARCH, params);
  };
  return { registerSearchEvent };
}
